// utils/tradeMetrics.js

export const calculateTradeMetrics = (trades, userSettings = {}) => {
  const validTrades = trades.filter((trade) => typeof trade.pnl === "number");

  if (!validTrades.length) {
    return {
      totalTrades: 0,
      winningTrades: 0,
      totalProfits: 0,
      totalLosses: 0,
      dailyPnL: 0,
      profitFactor: 0,
      winRate: 0,
      averageWinPercent: 0,
      averageLossPercent: 0,
    };
  }

  // Calculate total profits and losses separately
  const profits = validTrades.reduce((sum, trade) => {
    return trade.pnl > 0 ? sum + trade.pnl : sum;
  }, 0);

  const losses = Math.abs(
    validTrades.reduce((sum, trade) => {
      return trade.pnl < 0 ? sum + trade.pnl : sum;
    }, 0)
  );

  // Calculate win rate
  const winningTradesCount = validTrades.filter(
    (trade) => trade.pnl > 0
  ).length;
  const winRate = (winningTradesCount / validTrades.length) * 100;

  // Calculate profit factor
  const profitFactor =
    losses === 0 ? profits : Number((profits / losses).toFixed(2));

  // Calculate today's P&L
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dailyPnL = validTrades.reduce((sum, trade) => {
    const tradeDate = new Date(trade.date);
    tradeDate.setHours(0, 0, 0, 0);
    if (tradeDate.getTime() === today.getTime()) {
      return sum + trade.pnl;
    }
    return sum;
  }, 0);

  // Calculate winning and losing trades arrays for average percentage calculations
  const winningTradesArr = validTrades.filter((trade) => trade.pnl > 0);
  const losingTradesArr = validTrades.filter((trade) => trade.pnl < 0);

  // Calculate average win percentage
  const averageWinPercent =
    winningTradesArr.length > 0
      ? winningTradesArr.reduce((sum, trade) => {
          const percentReturn =
            ((trade.exitPrice - trade.entryPrice) / trade.entryPrice) * 100;
          return sum + percentReturn;
        }, 0) / winningTradesArr.length
      : 0;

  // Calculate average loss percentage (using absolute values)
  const averageLossPercent =
    losingTradesArr.length > 0
      ? losingTradesArr.reduce((sum, trade) => {
          const percentReturn =
            ((trade.exitPrice - trade.entryPrice) / trade.entryPrice) * 100;
          return sum + Math.abs(percentReturn);
        }, 0) / losingTradesArr.length
      : 0;

  return {
    totalTrades: validTrades.length,
    winningTrades: winningTradesCount,
    totalProfits: profits,
    totalLosses: losses,
    dailyPnL,
    profitFactor,
    winRate: Number(winRate.toFixed(1)),
    averageWinPercent: Number(averageWinPercent.toFixed(2)),
    averageLossPercent: Number(averageLossPercent.toFixed(2)),
  };
};

export default calculateTradeMetrics;
